import { NgModule } from '@angular/core';
import { AppModule } from './app.module';
import { AppComponent } from './app.component';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
@NgModule({
  imports: [AppModule],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: RESPONSE,
      useValue: null,
    }
  ]
})
export class AppBrowserModule { }
